import { GithubLogo, Moon, Sun } from '@phosphor-icons/react'

export type Theme = 'light' | 'dark'

interface AppHeaderProps {
  compact?: boolean
  onHome?: () => void
  onThemeChange: (theme: Theme) => void
  theme: Theme
}

export function AppHeader({ compact = false, onHome, onThemeChange, theme }: AppHeaderProps) {
  const brand = (
    <>
      <span className="brand-mark" aria-hidden="true">
        <span />
        <span />
        <span />
      </span>
      <span className="brand-copy">
        <strong>清单差异雷达</strong>
        <small>BOQ Diff</small>
      </span>
    </>
  )

  return (
    <header className={compact ? 'app-header app-header--compact' : 'app-header'}>
      {onHome ? (
        <button className="brand-button" type="button" onClick={onHome} aria-label="返回首页">
          {brand}
        </button>
      ) : (
        <div className="brand-button" style={{ cursor: 'default' }}>
          {brand}
        </div>
      )}

      <nav className="header-actions" aria-label="页面操作">
        <a
          className="icon-button"
          href="https://github.com/KanadeK/boq-diff"
          target="_blank"
          rel="noreferrer"
          aria-label="在 GitHub 查看项目"
          title="GitHub"
        >
          <GithubLogo aria-hidden="true" weight="regular" />
        </a>
        <button
          className="icon-button"
          type="button"
          onClick={() => onThemeChange(theme === 'light' ? 'dark' : 'light')}
          aria-label={theme === 'light' ? '切换到深色主题' : '切换到浅色主题'}
          title={theme === 'light' ? '深色主题' : '浅色主题'}
        >
          {theme === 'light' ? (
            <Moon aria-hidden="true" weight="regular" />
          ) : (
            <Sun aria-hidden="true" weight="regular" />
          )}
        </button>
      </nav>
    </header>
  )
}
